
import HRPage from '../../pages/HRpage/HRpage';
import LeadsenseJobMulti from '../../pages/Leadsense_job/Leadsense_job';
import JobLeads from '../../pages/LeadsenseJob/LeadsensestudentJob';
import Logout from '../../pages/Logout/Logout';
import Settings from '../../pages/setting/SettingPortal';
import UserManage from '../../pages/usersmanage/UserManage';

const HRroutes = [
    { path: "/", name: "KIIT_University", element: HRPage, exact: true },
    { path: "/logout", name: "KIIT_University", element: Logout, exact: true },
    { path: "/student/added", name: "KIIT_University", element: LeadsenseJobMulti, exact: true },
    { path: "/leadsense-job", name: "KIIT_University", element: JobLeads, exact: true },
    { path: "/settings", name: "KIIT_University", element: Settings, exact: true },
    { path: "/usermanage", name: "KIIT_University", element: UserManage, exact: true },
]

export default HRroutes;